// 支付路由
const verify = {
    path: 'pay',
    component: () => import('@/components/RouterView'),
    meta: {title: '年服务付费'},
    children: [
        {
            path: '',
            component: () => import('@/views/manage/pay'),
            meta: { title: '年服务付费'},
        }
    ]
}

export default verify